import {useLocation} from 'react-router-dom';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {PermissionsProvider, SearchBar, Select} from '@/components';
import {getTierStatusOptions} from '@/constants/formatters';
import type {AfriexQueryParams, AfriexRate, UserType} from '@/types';

import TierUpdateButton from './TierUpdateButton';

export type PromoTiersFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters?: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete: (search: string) => void;
  appRates: AfriexRate[];
  target: UserType;
  /** Test hook prefix for the create action and its form. */
  dataCy?: string;
};

const PromoTiersFilters = ({
  currentFilters,
  selectCurrentFilters,
  clearFilters,
  handleAutoComplete,
  appRates,
  target,
  dataCy,
}: PromoTiersFiltersProps) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = Boolean(queryParams.get('status'));

  return (
    <div className="mt-5 w-full">
      <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
        {/* Search Bar */}
        <SearchBar
          handleSearch={handleAutoComplete}
          handleAutoComplete={handleAutoComplete}
          placeholder="Search by Tier Name"
          clearFilters={clearFilters}
          inputClassName="w-full md:w-2/5"
        />
        <div className="flex gap-3 items-center justify-start md:justify-end">
          {/* Status Select Box */}
          <div className="flex flex-wrap gap-3 items-center md:space-x-3">
            {!status && (
              <Select
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  selectCurrentFilters('status', e.target.value)
                }
                value={currentFilters.status}
                name="status"
                options={getTierStatusOptions()}
                placeholder="Filter by Status"
              />
            )}

            <PermissionsProvider
              permission={AfriexAdminPermission.RatePromoManage}
            >
              <TierUpdateButton
                target={target}
                rawAppRates={appRates}
                dataCy={dataCy ? `${dataCy}-create` : undefined}
                formDataCy={dataCy ? `${dataCy}-form` : undefined}
              />
            </PermissionsProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoTiersFilters;
